import { MomentDefaultFormat, DateTimeFormat } from "./constantsExport.class";
export class MomentFormats{
    public static momentFormats = [MomentDefaultFormat, DateTimeFormat];
}